import { generateUUID } from "@wix/form-schema";
import React__default, { useRef } from "react";
const useId = typeof React__default.useId === "function" ? React__default.useId : () => useRef(generateUUID()).current;
export {
  useId
};
//# sourceMappingURL=use-id.js.map
